'use client';

import { useState } from 'react';

export type CheckboxOption = {
  value: string;
  label: string;
};
type Props = {
  option: CheckboxOption;
  name: string;
  checked?: boolean;
  onValueChange?: (value: string) => void;
};

export const Checkbox = ({ checked, onValueChange, name, option }: Props) => {
  const [selected, setSelected] = useState<boolean>(() => checked ?? false);

  const handleOnChange = () => {
    if (onValueChange) {
      onValueChange(option.value);
    }
    setSelected((prev) => !prev);
  };

  return (
    <div className="checkbox-container w-fit flex gap-2 relative">
      <input
        type="checkbox"
        className="cursor-pointer"
        id={`${name}-${option.value}`}
        name={name}
        value={option.value}
        checked={selected}
        onChange={() => handleOnChange()}
      />
      <label htmlFor={`${name}-${option.value}`} className="cursor-pointer">
        {option.label}
      </label>
      <span className="checkmark" onClick={() => handleOnChange()}></span>
    </div>
  );
};
